module.exports = __webpack_public_path__ + "img/unfold-icon-6.5a5ada96.png";